module.exports = __webpack_public_path__ + "static/media/应用图片111_03.82b7fff4.png";